<template>
  <div>
    <div v-if="$root.$i18n.locale === 'en'" class="error">
      <h3>Translation Missing</h3>
      <p>We apologize that this page has not been translated yet.</p>
    </div>
    <div v-if="success">
      <h2>Fertig!</h2>
      <p>Deine E-Mail-Adresse wurde bestätigt!</p>
    </div>
    <div v-else-if="error">
      <h2>Fehler</h2>
      <p>{{error}}</p>
    </div>
    <div v-else>
      <h2>Verarbeitung läuft...</h2>
    </div>
  </div>
</template>


<script>
  const axios = require('axios');
  export default {
    data() {
      return {
        success: null,
        error: null
      }
    },
    mounted() {
      let id = this.$route.query.id;
      if (!id) {
        this.error = 'Ungültige ID'
      }
      axios.post('https://contact.frechdax-abdl.de/api/tickets/offer', {
        id: id
      }).then(response => response.data)
           .then(() => {
             this.success = true;
           })
           .catch(error => {
             console.error(error);
             this.error = error.response.data;
           })
    }
  }
</script>
